/* ===================================================================
   NOUTOAIKATAULU  →  assets/pickup-scheduler.js
   ===================================================================
   - Renderöi paikka → päivä → aika -valinnan korissa (ja minicartissa).
   - Rajaa valittavat päivät: ei maanantaita, ei suljettuja, processing-ikkuna.
   - Täyttää aikaslotit paikan aikaryhmän + viikonpäivän mukaan.
   - Tallentaa valinnat cart-attributeihin (/cart/update.js):
       Noutopaikka / Noutopäivä / Noutoaika
   - Hallitsee 10 € piilotuotteen (add/change) paikan maksun mukaan.
   - Lukitsee kaikki [data-checkout]-napit kunnes kolmikko täytetty.

   Ei riippuvuuksia. Event-delegaatio → kestää minicartin innerHTML-swapit.
   =================================================================== */
(function () {
  'use strict';

  var WEEKDAY_FI = ['sunnuntai','maanantai','tiistai','keskiviikko','torstai','perjantai','lauantai'];
  var busy = false;               // estä päällekkäiset cart-kirjoitukset
  var config = null;              // jaettu konfiguraatio (ensimmäisestä [data-pickup])
  var feeVariant = '';

  /* ---------- APURIT ---------- */

  function pad(n){ return n < 10 ? '0' + n : '' + n; }

  // Date-objekti → 'YYYY-MM-DD' (paikallinen, ei UTC-siirtymää)
  function ymd(d){ return d.getFullYear() + '-' + pad(d.getMonth()+1) + '-' + pad(d.getDate()); }

  // 'YYYY-MM-DD' → Date (paikallinen keskiyö)
  function parseYmd(s){
    var p = String(s).split('-');
    if (p.length !== 3) return null;
    return new Date(+p[0], +p[1]-1, +p[2]);
  }

  // Tallennusmuoto (cart-attribuutti / admin): suomalainen 'D.M.YYYY'.
  // Sisäisesti käsitellään aina ISO 'YYYY-MM-DD'.
  function toFi(iso){
    var d = parseYmd(iso);
    return d ? (d.getDate() + '.' + (d.getMonth()+1) + '.' + d.getFullYear()) : '';
  }
  // Hyväksyy sekä 'D.M.YYYY' että vanhan 'YYYY-MM-DD' (olemassa olevat korit).
  function toIso(s){
    s = String(s || '').trim();
    var m = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
    if (m) return m[3] + '-' + pad(+m[2]) + '-' + pad(+m[1]);
    return /^\d{4}-\d{2}-\d{2}$/.test(s) ? s : '';
  }

  // 'HH:MM' → minuutit
  function toMin(hhmm){ var p = hhmm.split(':'); return (+p[0])*60 + (+p[1]); }
  function fromMin(m){ return pad(Math.floor(m/60)) + ':' + pad(m%60); }

  // Aikaisin sallittu noutopäivä = tilauspäivän jälkeen väliin pitää mahtua
  // vähintään N KOKONAISTA arkipäivää (ma–pe). Viikonloput eivät kuluta
  // prosessointia. Esim. ma tilaus + 4 arkipäivää (ti,ke,to,pe) → aikaisin la.
  function isBusinessDay(d){ var w = d.getDay(); return w !== 0 && w !== 6; }
  function earliestDate(){
    var today = new Date(); today.setHours(0,0,0,0);
    var dow = today.getDay();  // 0..6
    var need = config.processing_days || 0;
    if (config.processing_override && config.processing_override[String(dow)] != null) {
      need = config.processing_override[String(dow)];
    }
    var d = new Date(today);
    var counted = 0;
    // Laske eteenpäin, kunnes N kokonaista arkipäivää on kulunut väliin.
    while (counted < need) {
      d.setDate(d.getDate() + 1);
      if (isBusinessDay(d)) counted++;
    }
    // d on nyt viimeinen väliin laskettu arkipäivä → aikaisin nouto = seuraava päivä.
    d.setDate(d.getDate() + 1);
    return d;
  }

  // Onko päivä valittavissa annetulle paikalle?
  function isDateAllowed(dateStr, loc){
    var d = parseYmd(dateStr);
    if (!d) return false;
    var min = earliestDate();
    if (d < min) return false;                                   // processing-ikkuna
    var dow = d.getDay();
    if ((config.closed_weekdays || []).indexOf(dow) !== -1) return false; // globaali (esim. ma)
    if (loc && loc.closed_weekdays && loc.closed_weekdays.indexOf(dow) !== -1) return false; // paikkakohtainen viikonpäiväsulku
    if (loc && loc.closed && loc.closed.indexOf(dateStr) !== -1) return false; // paikan pyhät
    return true;
  }

  // Seuraava sallittu päivä paikasta eteenpäin (kalenterin oletusarvoksi)
  function firstAllowedDate(loc){
    var d = earliestDate();
    for (var i = 0; i < 400; i++){
      var s = ymd(d);
      if (isDateAllowed(s, loc)) return s;
      d.setDate(d.getDate() + 1);
    }
    return '';
  }

  // Aikaslotit → valittavat kellonajat 60 min välein (slotin alusta loppuun asti, loppu mukaan lukien).
  function timesForDate(dateStr, loc){
    var d = parseYmd(dateStr);
    if (!d || !loc) return [];
    var group = (config.time_groups || {})[loc.group];
    if (!group) return [];
    var ranges = group[String(d.getDay())] || [];
    var out = [];
    ranges.forEach(function(r){
      var start = toMin(r[0]), end = toMin(r[1]);
      for (var m = start; m <= end; m += 60){ out.push(fromMin(m)); }
    });
    return out;
  }

  function locByName(name){
    if (!config) return null;
    var list = config.locations || [];
    for (var i = 0; i < list.length; i++){ if (list[i].name === name) return list[i]; }
    return null;
  }

  function money(cents){
    // Suomityylinen euroformaatti: "10,00 €"
    var v = (cents/100).toFixed(2).replace('.', ',');
    return v + '\u00A0€';
  }

  /* ---------- CART-KIRJOITUS ---------- */

  function updateAttributes(attrs){
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function(r){ return r.json(); });
  }

  // Muistissa: onko maksurivi korissa + sen key. Vältetään turha /cart.js-haku.
  var feeState = { known:false, inCart:false, key:null };

  // Echo-guard: kun reconcileFee juuri muutti koria, seuraava cart:changed on
  // meidän oma kaikumme → ohitetaan varmistuskierros (turha render + haku).
  // Allekirjoitus = item_count + total_price, jottei aito samankokoinen muutos
  // (esim. tuote poistettu & maksu lisätty samalla count-arvolla) mene ohi.
  var lastReconcileSig = '';
  function cartSig(c){
    return (c && typeof c.item_count !== 'undefined')
      ? (c.item_count + ':' + c.total_price) : '';
  }

  // Lue maksurivin tila annetusta cart-objektista (päivittää muistin).
  function readFeeState(cart){
    var line = null;
    (cart.items || []).forEach(function(it){
      if (String(it.variant_id) === String(feeVariant)) line = it;
    });
    feeState.known = true;
    feeState.inCart = !!line;
    feeState.key = line ? line.key : null;
    return line;
  }

  // Onko korissa muita tuotteita kuin maksurivi?
  function hasRealItems(cart){
    if (!cart || !cart.items) return false;
    return cart.items.some(function(it){
      return String(it.variant_id) !== String(feeVariant);
    });
  }

  // Sovita maksurivi korin ja valitun paikan mukaan. Kattaa kolme tapausta:
  //  1) Korissa VAIN maksurivi (ei oikeita tuotteita) → poista maksu (orpo).
  //  2) Paikka maksullinen + oikeita tuotteita, mutta maksu puuttuu → lisää maksu.
  //  3) Paikka ilmainen/ei valittu, mutta maksu korissa → poista maksu.
  // Palauttaa promisen muutetusta cart-objektista, tai null jos ei muutosta.
  function reconcileFee(cart){
    if (!feeVariant || !cart || !cart.items) return Promise.resolve(null);

    var feeLine = null;
    cart.items.forEach(function(it){
      if (String(it.variant_id) === String(feeVariant)) feeLine = it;
    });
    var real = hasRealItems(cart);
    // Lue paikka ENSISIJAISESTI korin attribuuteista (aina tuore), muistista vasta
    // fallbackina. Korjaa ajoitusongelman: cart:changed voi laueta ennen kuin
    // scheduler on ehtinyt täyttää muistin restore-vaiheessa.
    var locName = (cart.attributes && cart.attributes['Noutopaikka']) || getAttr('Noutopaikka');
    var loc = locByName(locName);
    var wantFee = !!(loc && loc.fee > 0);

    // Yhteinen lopetus: päivitä maksurivin muisti JA merkitse tuloksen item_count
    // echo-guardiin, jotta seuraava cart:changed (meidän oma kaikumme) ohitetaan.
    function finalize(c){
      readFeeState(c);
      lastReconcileSig = cartSig(c);
      return c;
    }
    function postUpdate(updates){
      return fetch('/cart/update.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function(r){ return r.json(); }).then(finalize);
    }

    // 1) Orpo maksu: vain maksurivi jäljellä → poista.
    if (feeLine && !real){
      var updRm = {}; updRm[feeLine.key] = 0;
      return postUpdate(updRm);
    }

    // 2) Maksu puuttuu vaikka pitäisi olla (paikka maksullinen + oikeita tuotteita).
    // update.js { updates: { <variant_id>: 1 } } asettaa maksurivin määräksi 1 JA
    // palauttaa koko korin yhdellä pyynnöllä (ei erillistä add.js + cart.js -paria).
    if (!feeLine && real && wantFee){
      var updAdd = {}; updAdd[String(feeVariant)] = 1;
      return postUpdate(updAdd);
    }

    // 3) Maksu korissa vaikka ei pitäisi (ilmainen paikka tai ei valintaa).
    if (feeLine && real && !wantFee){
      var updClr = {}; updClr[feeLine.key] = 0;
      return postUpdate(updClr);
    }

    return Promise.resolve(null);
  }

  // Varmista maksurivin tila. Palauttaa aina lopullisen cart-objektin (tai null jos
  // maksua ei ole). want=true → rivi määrällä 1, want=false → poistettu.
  function syncFeeLine(want){
    if (!feeVariant) return Promise.resolve(null);

    // Jos tila on tiedossa muistista, toimi suoraan ilman hakua.
    function apply(){
      if (want && !feeState.inCart){
        return fetch('/cart/add.js', {
          method:'POST',
          headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
          body: JSON.stringify({ id: Number(feeVariant), quantity: 1, sections: [] })
        }).then(function(){ return fetch('/cart.js').then(function(r){return r.json();}); });
      }
      if (!want && feeState.inCart){
        // update.js poistaa rivin (quantity 0) JA palauttaa cart-objektin → 1 pyyntö
        var upd = {}; upd[feeState.key] = 0;
        return fetch('/cart/update.js', {
          method:'POST',
          headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
          body: JSON.stringify({ updates: upd })
        }).then(function(r){ return r.json(); });
      }
      return null;  // ei muutosta tarpeen
    }

    if (feeState.known){
      var res = apply();
      if (res) return res.then(function(cart){ if (cart) readFeeState(cart); return cart; });
      return Promise.resolve(null);
    }

    // Ensimmäinen kerta: hae kori kerran, tallenna tila, toimi.
    return fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        readFeeState(cart);
        var res = apply();
        if (res) return res.then(function(c){ if (c) readFeeState(c); return c; });
        return null;
      });
  }

  /* ---------- CHECKOUT-LUKITUS ---------- */

  function selectionComplete(){
    var loc = getAttr('Noutopaikka'), date = getAttr('Noutopäivä'), time = getAttr('Noutoaika');
    if (!loc || !date || !time) return false;
    // varmista että tallennettu päivä on yhä sallittu (esim. processing muuttunut)
    var l = locByName(loc);
    return !!l && isDateAllowed(date, l) && timesForDate(date, l).indexOf(time) !== -1;
  }

  // Cart-attribuutit luetaan DOM:n data-current-* -kentistä + oman muistin päälle.
  var mem = { Noutopaikka:'', 'Noutopäivä':'', Noutoaika:'' };
  function getAttr(k){ return mem[k] || ''; }
  function setAttr(k,v){ mem[k] = v || ''; }

  // Sovita KAIKKIEN schedulerien maksurivit jaetusta tilasta (mem).
  // Korjaa bugin: cart-sivulla on kaksi [data-pickup]-instanssia (sivu + drawer),
  // joilla omat fee-boxit. Yhden instanssin locSel.change päivitti vain oman
  // reflectFeen → toisen kosmeettinen "Noutomaksu"-rivi jäi maksullisen paikan
  // arvoon vaihdettaessa maksullinen → maksuton. Nyt kaikki päivittyvät kerralla.
  function reflectAllFees(){
    var loc = locByName(getAttr('Noutopaikka'));
    var show = !!(loc && loc.fee > 0 && feeVariant);
    document.querySelectorAll('[data-pickup]').forEach(function(root){
      var box = root.querySelector('[data-pickup-fee]');
      var amt = root.querySelector('[data-pickup-fee-amt]');
      if (!box) return;
      if (show){ box.hidden = false; if (amt) amt.textContent = money(loc.fee); }
      else { box.hidden = true; }
    });
  }

  function refreshCheckoutLock(){
    var ok = selectionComplete();
    document.querySelectorAll('[data-checkout]').forEach(function(btn){
      var isLink = btn.tagName === 'A';
      if (ok){
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('is-locked');
      } else {
        if (isLink){ btn.setAttribute('aria-disabled','true'); }
        else { btn.setAttribute('disabled',''); }
        btn.classList.add('is-locked');
      }
    });
    // status-teksti jokaiseen scheduleriin
    document.querySelectorAll('[data-pickup-status]').forEach(function(el){
      el.textContent = ok ? '✓ Valittu' : 'Valitse ajankohta';
      el.classList.toggle('is-missing', !ok);
      el.classList.toggle('is-done', ok);
    });
  }

  // Estä lukitun checkout-linkin klikkaus (minicart <a>)
  document.addEventListener('click', function(e){
    var link = e.target.closest('[data-checkout]');
    if (link && link.tagName === 'A' && link.getAttribute('aria-disabled') === 'true'){
      e.preventDefault();
      // scrollaa scheduleriin jos näkyvissä
      var sched = document.querySelector('[data-pickup]');
      if (sched) sched.scrollIntoView({ behavior:'smooth', block:'center' });
    }
  });

  /* ---------- UI-RAKENNUS ---------- */

  function buildLocationOptions(sel){
    if (!config) return;
    var cur = sel.value;
    sel.innerHTML = '<option value="">Valitse noutopaikka…</option>';
    (config.locations || []).forEach(function(loc){
      var opt = document.createElement('option');
      opt.value = loc.name;
      opt.textContent = loc.fee > 0 ? (loc.name + ' — ' + money(loc.fee)) : (loc.name + ' — ilmainen');
      sel.appendChild(opt);
    });
    if (cur) sel.value = cur;
  }

  function buildTimeOptions(sel, times, keep){
    sel.innerHTML = '';
    if (!times.length){
      sel.innerHTML = '<option value="">Ei vapaita aikoja</option>';
      return;
    }
    var ph = document.createElement('option');
    ph.value = ''; ph.textContent = 'Valitse noutoaika…';
    sel.appendChild(ph);
    times.forEach(function(t){
      var o = document.createElement('option');
      o.value = t; o.textContent = t;
      sel.appendChild(o);
    });
    if (keep && times.indexOf(keep) !== -1) sel.value = keep;
  }

  var MONTHS_FI = ['tammikuu','helmikuu','maaliskuu','huhtikuu','toukokuu','kesäkuu',
                   'heinäkuu','elokuu','syyskuu','lokakuu','marraskuu','joulukuu'];

  function sameYmd(a,b){ return a === b; }

  /* ---------- SCHEDULER-INSTANSSI ---------- */

  function initScheduler(root){
    if (root.__pickupInit) return;
    root.__pickupInit = true;

    // config vain kerran (jaettu)
    if (!config){
      try { config = JSON.parse(root.getAttribute('data-pickup-config') || '{}'); }
      catch (e){ config = null; }
    }
    if (!feeVariant){ feeVariant = root.getAttribute('data-pickup-fee-variant') || ''; }
    if (!config || !config.locations){ return; }

    // esitäytä muisti cart-attributeista (DOM data-current-*)
    var cLoc = root.getAttribute('data-current-location') || '';
    var cDate = root.getAttribute('data-current-date') || '';
    var cTime = root.getAttribute('data-current-time') || '';
    if (cLoc && !getAttr('Noutopaikka')) setAttr('Noutopaikka', cLoc);
    if (cDate && !getAttr('Noutopäivä')) setAttr('Noutopäivä', toIso(cDate));
    if (cTime && !getAttr('Noutoaika')) setAttr('Noutoaika', cTime);

    var locSel = root.querySelector('[data-pickup-location]');
    var dateStep = root.querySelector('[data-pickup-step="date"]');
    var timeStep = root.querySelector('[data-pickup-step="time"]');
    var dateInput = root.querySelector('[data-pickup-date]');
    var dateHint = root.querySelector('[data-pickup-date-hint]');
    var dateTrigger = root.querySelector('[data-pickup-date-trigger]');
    var dateLabel = root.querySelector('[data-pickup-date-label]');
    var cal = root.querySelector('[data-pickup-cal]');
    var calMonth = root.querySelector('[data-cal-month]');
    var calGrid = root.querySelector('[data-cal-grid]');
    var calPrev = root.querySelector('[data-cal-prev]');
    var calNext = root.querySelector('[data-cal-next]');
    var timeSel = root.querySelector('[data-pickup-time]');
    var feeBox = root.querySelector('[data-pickup-fee]');
    var feeAmt = root.querySelector('[data-pickup-fee-amt]');

    var calView = null;  // {year, month} näkyvä kuukausi

    buildLocationOptions(locSel);

    // 'YYYY-MM-DD' → 'pe 12.6.2026'
    function humanDate(s){
      var d = parseYmd(s); if (!d) return '';
      var wd = ['su','ma','ti','ke','to','pe','la'][d.getDay()];
      return wd + ' ' + d.getDate() + '.' + (d.getMonth()+1) + '.' + d.getFullYear();
    }

    function reflectFee(loc){
      // Sovita KAIKKIEN schedulerien maksurivit jaetusta tilasta (mem), ei vain
      // tämän instanssin — muuten toinen instanssi (cart-sivu vs. drawer) jää
      // maksullisen paikan arvoon vaihdettaessa maksullinen → maksuton.
      reflectAllFees();
    }

    function renderCalendar(loc){
      if (!calView){
        var e = parseYmd(getAttr('Noutopäivä')) || earliestDate();
        calView = { year: e.getFullYear(), month: e.getMonth() };
      }
      var y = calView.year, m = calView.month;
      calMonth.textContent = MONTHS_FI[m].charAt(0).toUpperCase() + MONTHS_FI[m].slice(1) + ' ' + y;

      // ma-alkuinen ruudukko: montako tyhjää ennen 1. päivää
      var first = new Date(y, m, 1);
      var offset = (first.getDay() + 6) % 7;  // 0=ma
      var daysInMonth = new Date(y, m+1, 0).getDate();
      var selected = getAttr('Noutopäivä');
      var todayStr = ymd(new Date());

      var html = '';
      for (var i = 0; i < offset; i++){ html += '<span class="pickup__cal-cell is-empty"></span>'; }
      for (var d = 1; d <= daysInMonth; d++){
        var ds = y + '-' + pad(m+1) + '-' + pad(d);
        var allowed = isDateAllowed(ds, loc);
        var cls = 'pickup__cal-cell';
        if (!allowed) cls += ' is-disabled';
        if (allowed && sameYmd(ds, selected)) cls += ' is-selected';
        if (sameYmd(ds, todayStr)) cls += ' is-today';
        html += allowed
          ? '<button type="button" class="' + cls + '" data-cal-day="' + ds + '">' + d + '</button>'
          : '<span class="' + cls + '">' + d + '</span>';
      }
      calGrid.innerHTML = html;

      // nav-nappien rajat: ei menneisyyteen alle min-kuukauden, max +12kk
      var minD = earliestDate();
      var minMonth = minD.getFullYear()*12 + minD.getMonth();
      var viewMonth = y*12 + m;
      calPrev.disabled = viewMonth <= minMonth;
      var maxMonth = minMonth + 12;
      calNext.disabled = viewMonth >= maxMonth;
    }

    function openCal(loc){
      calView = null;  // laske näkyvä kuukausi uudelleen valitusta/min-päivästä
      renderCalendar(loc);
      cal.hidden = false;
      dateTrigger.setAttribute('aria-expanded','true');
      // Avaa ylöspäin jos triggerin alla ei ole tarpeeksi tilaa (esim. minicart-footer)
      cal.classList.remove('pickup__cal--up');
      var rect = dateTrigger.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var spaceBelow = vh - rect.bottom;
      var needed = cal.offsetHeight + 16;
      if (spaceBelow < needed && rect.top > needed){
        cal.classList.add('pickup__cal--up');
      }
    }
    function closeCal(){
      cal.hidden = true;
      dateTrigger.setAttribute('aria-expanded','false');
    }

    function showDateStep(loc){
      dateStep.hidden = false;
      var sel = getAttr('Noutopäivä');
      dateLabel.textContent = sel ? humanDate(sel) : 'Valitse päivä…';
      dateTrigger.classList.toggle('is-empty', !sel);
      if (dateHint){
        dateHint.textContent = 'Aikaisintaan ' + humanDate(ymd(earliestDate())) + '.';
      }
    }

    function showTimeStep(times){
      buildTimeOptions(timeSel, times, getAttr('Noutoaika'));
      timeStep.hidden = false;
    }

    // Palauta tallennettu tila UI:hin
    (function restore(){
      var loc = getAttr('Noutopaikka');
      if (loc && locByName(loc)){
        locSel.value = loc;
        var l = locByName(loc);
        reflectFee(l);
        showDateStep(l);
        var date = getAttr('Noutopäivä');
        if (date && isDateAllowed(date, l)){
          dateInput.value = date;
          showTimeStep(timesForDate(date, l));
        }
      }
      refreshCheckoutLock();
      // Vanha ISO-muoto korissa (2026-10-02) → kirjoita heti suomalaisena (2.10.2026),
      // ettei tilaukselle päädy viivamuotoa vaikka asiakas ei muuta valintaa.
      if (cDate && cDate.indexOf('-') !== -1 && toIso(cDate)){ persist(null, false); }
    })();

    /* --- Tapahtumat --- */

    locSel.addEventListener('change', function(){
      var name = locSel.value;
      var loc = locByName(name);
      setAttr('Noutopaikka', name);
      // paikan vaihtuessa nollaa päivä+aika jos ei enää kelpaa
      var date = getAttr('Noutopäivä');
      if (!loc || !date || !isDateAllowed(date, loc)){
        setAttr('Noutopäivä',''); setAttr('Noutoaika','');
        if (dateInput) dateInput.value = '';
        timeStep.hidden = true;
      }
      reflectFee(loc);
      if (loc){ showDateStep(loc); } else { dateStep.hidden = true; timeStep.hidden = true; }
      refreshCheckoutLock();
      persist(loc, true);   // paikanvaihto voi muuttaa maksua → sovita
    });

    // Avaa/sulje kalenteri
    dateTrigger.addEventListener('click', function(){
      var loc = locByName(getAttr('Noutopaikka'));
      if (!loc) return;
      if (cal.hidden) openCal(loc); else closeCal();
    });

    // Kuukausinavigointi
    calPrev.addEventListener('click', function(){
      if (calPrev.disabled) return;
      calView.month--; if (calView.month < 0){ calView.month = 11; calView.year--; }
      renderCalendar(locByName(getAttr('Noutopaikka')));
    });
    calNext.addEventListener('click', function(){
      if (calNext.disabled) return;
      calView.month++; if (calView.month > 11){ calView.month = 0; calView.year++; }
      renderCalendar(locByName(getAttr('Noutopaikka')));
    });

    // Päivän valinta
    calGrid.addEventListener('click', function(e){
      var cell = e.target.closest('[data-cal-day]');
      if (!cell) return;
      var loc = locByName(getAttr('Noutopaikka'));
      var date = cell.getAttribute('data-cal-day');
      if (!loc || !isDateAllowed(date, loc)) return;
      dateInput.value = date;
      setAttr('Noutopäivä', date);
      setAttr('Noutoaika','');              // nollaa aika kun päivä vaihtuu
      dateLabel.textContent = humanDate(date);
      dateTrigger.classList.remove('is-empty');
      closeCal();
      showTimeStep(timesForDate(date, loc));
      refreshCheckoutLock();
      persist(loc, false);  // päivänvaihto ei muuta maksua → vain attribuutit
    });

    // Sulje kalenteri klikatessa ulkopuolelle
    document.addEventListener('click', function(e){
      if (cal.hidden) return;
      if (!cal.contains(e.target) && e.target !== dateTrigger && !dateTrigger.contains(e.target)){
        closeCal();
      }
    });

    timeSel.addEventListener('change', function(){
      setAttr('Noutoaika', timeSel.value);
      refreshCheckoutLock();
      persist(locByName(getAttr('Noutopaikka')), false);  // ajanvaihto ei muuta maksua
    });

    // Tallenna cart-attribuutit, sitten sovita maksurivi (reconcileFee = ainoa
    // paikka joka lisää/poistaa maksun → ei kilpailevia polkuja). busy-lukko estää
    // päällekkäiset kirjoitukset.
    // doReconcile: aja maksun sovitus vain kun se voi muuttua (= paikanvaihto).
    // Päivä/aika-valinnat eivät koskaan muuta maksua → tallennetaan pelkät attribuutit.
    function persist(loc, doReconcile){
      if (busy){ return; }
      busy = true;
      var attrs = {
        'Noutopaikka': getAttr('Noutopaikka'),
        'Noutopäivä': toFi(getAttr('Noutopäivä')),
        'Noutoaika': getAttr('Noutoaika')
      };
      updateAttributes(attrs)
        .then(function(updatedCart){
          // updateAttributes palauttaa tuoreen korin (sis. juuri tallennetut attribuutit)
          if (!doReconcile) return updatedCart;
          return reconcileFee(updatedCart).then(function(changed){
            return changed || updatedCart;  // reconcile-tulos jos muutti, muuten sama kori
          });
        })
        .then(function(cart){
          busy = false;
          document.dispatchEvent(new CustomEvent('pickup:updated', { detail: { cart: cart } }));
        })
        .catch(function(){ busy = false; });
    }
  }

  /* ---------- ALUSTUS ---------- */

  function initAll(){
    document.querySelectorAll('[data-pickup]').forEach(initScheduler);
    refreshCheckoutLock();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Minicart voi injektoida schedulerin myöhemmin → alusta uudelleen.
  // Nollaa maksurivin muisti: kori on voinut muuttua drawerin avaamisen välillä.
  document.addEventListener('cart-drawer:rendered', function(){
    feeState.known = false;
    initAll();
  });
  // Section Rendering / korin uudelleenrenderöinti
  document.addEventListener('shopify:section:load', initAll);

  // Korin muutos (mistä tahansa): sovita maksurivi korin ja valitun paikan mukaan.
  //  - vain maksurivi jäljellä → poista
  //  - maksu puuttuu vaikka paikka maksullinen + oikeita tuotteita → lisää (korjaa
  //    bugin: kori tyhjennettiin, paikka jäi muistiin, uusi tuote ei saanut maksua)
  //  - maksu korissa vaikka paikka ilmainen → poista
  // Jos muutos tehtiin, laukaisee pickup:updated → kori renderöityy uudelleen.
  // Silmukka päättyy: toisella kierroksella tila on jo sovitettu → null.
  var pendingCart = null;           // busy-lukon aikana saapunut kori → aja lukon vapauduttua
  function runReconcile(cart){
    // Echo-guard: tämä kori on reconcilen oma tulos (allekirjoitus täsmää) → ei uutta
    // kierrosta. Kuluta lippu kertakäyttöisenä, ettei se estä aitoja muutoksia.
    var sig = cartSig(cart);
    if (sig && sig === lastReconcileSig){
      lastReconcileSig = '';
      return;
    }
    if (busy){ pendingCart = cart; return; }   // jonota, älä pudota
    busy = true;
    reconcileFee(cart).then(function(changed){
      busy = false;
      if (changed){
        document.dispatchEvent(new CustomEvent('pickup:updated', { detail: { cart: changed } }));
      }
      if (pendingCart){                          // aja lukon aikana jonoon jäänyt kori
        var q = pendingCart; pendingCart = null;
        runReconcile(q);
      }
    }).catch(function(){ busy = false; });
  }

  document.addEventListener('cart:changed', function(e){
    var cart = e && e.detail && e.detail.cart;
    if (!cart || !feeVariant) return;
    runReconcile(cart);
  });
})();